import { h } from 'preact'
import './styles'
import App from './components/App'
import { Provider } from 'preact-redux'
import store from './store'

const SmartApp = () => (
  <Provider store={store}>
    <App />
  </Provider>
)

export default SmartApp



// WEBPACK FOOTER //
// ./index.js